/**
 * Shim `react-native` for Next.js web builds.
 *
 * We alias `react-native` to this file so packages expecting `react-native`
 * (including some that import `unstable_batchedUpdates`) can run against
 * `react-native-web` in a browser/Next environment.
 */

const reactNativeWeb = require("react-native-web");
const { unstable_batchedUpdates } = require("react-dom");

module.exports = {
  ...reactNativeWeb,
  unstable_batchedUpdates,
};
